/* eslint-disable no-undef */
import { useState } from "react";
import ReactMarkdown from "react-markdown";
import { Clipboard, ClipboardCheck, Sparkles, UserRound } from "lucide-react";
import clsx from "clsx";

export const ChatMessage = ({ message, compact = false }) => {
  const [copied, setCopied] = useState(false);
  const isUser = message.role === "user";
  const label = isUser ? "Tú" : "Edunova AI";

  const handleCopy = async () => {
    const canCopy = typeof navigator !== "undefined" && navigator?.clipboard;
    if (!canCopy || !message?.content) return;

    try {
      await navigator.clipboard.writeText(message.content);
      setCopied(true);
      if (typeof window !== "undefined") {
        window.setTimeout(() => setCopied(false), 1500);
      }
    } catch (error) {
      setCopied(false);
    }
  };

  return (
    <div
      className={clsx(
        "ai-chat-message",
        isUser ? "ai-chat-message--user" : "ai-chat-message--assistant",
        compact && "ai-chat-message--compact"
      )}
    >
      <div className="ai-chat-message__avatar" aria-hidden>
        {isUser ? <UserRound size={20} /> : <Sparkles size={20} />}
      </div>
      <div className="ai-chat-message__body">
        <div className="ai-chat-message__meta">
          <span className="ai-chat-message__author">{label}</span>
          {message?.createdAt ? (
            <time dateTime={message.createdAt}>{
              new Date(message.createdAt).toLocaleTimeString("es-PE", {
                hour: "2-digit",
                minute: "2-digit",
              })
            }</time>
          ) : null}
          {message?.usage?.total_tokens ? (
            <span className="ai-chat-message__usage">
              {message.usage.total_tokens} tokens
            </span>
          ) : null}
          {message?.content && (
            <button
              className="ai-chat-message__copy"
              type="button"
              onClick={handleCopy}
              title="Copiar mensaje"
              aria-label="Copiar mensaje"
            >
              {copied ? <ClipboardCheck size={16} /> : <Clipboard size={16} />}
            </button>
          )}
        </div>
        <div className="ai-chat-message__content">
          {message?.isLoading ? (
            <div className="ai-chat-message__typing">
              <span />
              <span />
              <span />
            </div>
          ) : (
            <ReactMarkdown>{message?.content || ""}</ReactMarkdown>
          )}
        </div>
      </div>
    </div>
  );
};
